import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";

export const useViewMacrofamily = () => { 
    return useQuery({ 
        queryKey: ['viewMacrofamily'], 
        queryFn: async () => { 
            const res = await api.get('/macros/show', {
            }); 
            return res.data; 
        }
     });
};  